import { isTiptapComment } from "@/react/components/CommentsCompass/helpers";
import {
  ModalManager,
  useModal,
} from "@/react/components/Layout/ModalManagerProvider";
import type { Comment } from "@/react/types/Comment";

import { TiptapEditModal } from "./TiptapEditModal";
import { TrixEditModal } from "./TrixEditModal";

interface EditModalProps {
  comment: Comment;
  spaceId: number;
}

const EditModal = ModalManager.create(({ comment, spaceId }: EditModalProps) =>
  isTiptapComment(comment) ? (
    <TiptapEditModal comment={comment} spaceId={spaceId} />
  ) : (
    <TrixEditModal comment={comment} spaceId={spaceId} />
  ),
);

export const useEditModal = () => useModal(EditModal);
